angular.module('app.registration.profileTypesService', [])
  .factory('app.registration.profileTypesService', [
    '$http',
    function ($http) {
      "use strict";

      let service = {
        list: null,
        error: null,
        retrieve: function () {
          return $http.get(window.location.api('userprofiles/types'))
            .then(function (response) {
              let data = response.data;

              service.list = null;
              service.error = null;

              if (data.error) {
                service.error = data.error;
              }
              else {
                service.list = data;
              }
            });
        }
      };

      return service;
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/registration/profileTypesService.js